'use strict';

export default {
  notificationList: {
    organizationInvitationMessage: '{invitedBy} invites you to join the organization {organizationName}',
    empty: 'You have no notifications at this time.',
  },
};
